import { useFormikContext } from 'formik';
import i18n from 'i18next';
import React, { FunctionComponent, useEffect, useState } from 'react';
import { IMaskInput } from 'react-imask';
import { FormField } from '..';
import { FormFieldPropsBase } from './fieldset.model';

export interface RegistrationNumberFormFieldProps extends FormFieldPropsBase {}

export const RegistrationNumberFormField: FunctionComponent<RegistrationNumberFormFieldProps> = ({
  fieldName,
  labelTranslationKey = '',
  placeholderTranslationKey = '',
  testId,
  isDisabled,
}) => {
  const { values, setFieldTouched, setFieldValue } = useFormikContext<any>();
  const [inputValue, setInputValue] = useState('');

  const registrationNumberMask = {
    mask: (value: string) => {
      const cleanValue = value.replace(/[^a-zA-Z0-9]/g, '');

      let digitPart = '00';
      if (/^\d{3}/.test(cleanValue)) {
        digitPart = '000';
      }

      const letterPart = cleanValue.replace(/^\d{2,3}/, '');
      let letters = 'A';
      if (/^[a-zA-Z]{2}/.test(letterPart)) {
        letters = 'AA';
      }

      const remainingDigits = cleanValue.replace(/^\d{2,3}[a-zA-Z]{1,2}/, '').length;

      const digits = '0'.repeat(Math.min(remainingDigits, 10));

      return `${digitPart}-${letters}-${digits}`;
    },

    definitions: {
      '0': /\d/,
      A: /[a-zA-Z]/,
    },
  };

  const handleChange = (event) => {
    const newValue = event.target.value.toUpperCase();
    setInputValue(newValue);
    setFieldValue(fieldName, newValue);
  };

  const handleBlur = () => {
    setFieldTouched(fieldName, true, true);
  };

  useEffect(() => {
    if (values[fieldName]) {
      const value = values[fieldName];
      const newValue = value.toString().toUpperCase();
      setInputValue(newValue);
    }
  }, [values, fieldName]);

  return (
    <FormField
      type="input"
      name={fieldName}
      testId={testId}
      labelText={i18n.t(labelTranslationKey)}
      render={(fieldProps) => (
        <IMaskInput
          {...fieldProps}
          className="c-input__input"
          disabled={isDisabled}
          mask={registrationNumberMask.mask}
          definitions={registrationNumberMask.definitions}
          name={fieldName}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={i18n.t(placeholderTranslationKey)}
          placeholderChar={'\u2000'}
          value={inputValue}
        />
      )}
    />
  );
};
